import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import { findCityLandingSlug } from '../../util/cityLandingPageConfig';
import { NamedLink } from '../../components';

import css from './ListingPage.module.css';

/**
 * "More coworking spaces in Zurich" — the link back from a listing to its city page.
 *
 * Two jobs, one link. For the visitor it is the obvious next step when this particular space is
 * not the one: the listing page otherwise offers only more spaces from the same provider, so
 * someone who does not want this desk has to go back to the search they came from.
 *
 * For search engines it closes the internal link graph. The nine city pages are the ones meant to
 * rank for "coworking <city>", and until now nothing linked to them except the footer and each
 * other. The listings — by far the largest group of pages on the marketplace, and the ones with
 * real content — pointed nowhere. Every listing in the Zurich box now points at the Zurich page,
 * which is how a hub page gets its authority.
 *
 * Renders nothing when the listing sits outside every configured city box; an invented link to a
 * page that does not cover this place would help no one.
 *
 * @component
 * @param {Object} props
 * @param {{lat: number, lng: number}?} props.geolocation - the listing's location
 * @returns {JSX.Element|null}
 */
const SectionCityLinkMaybe = ({ geolocation }) => {
  const citySlug = findCityLandingSlug(geolocation);
  if (!citySlug) {
    return null;
  }

  return (
    <p className={css.cityLink}>
      <NamedLink className={css.cityLinkAnchor} name="CityLandingPage" params={{ citySlug }}>
        <FormattedMessage
          id="ListingPage.moreInCity"
          values={{
            city: <FormattedMessage id={`CityLandingPage.${citySlug}.placeName`} />,
          }}
        />
      </NamedLink>
    </p>
  );
};

export default SectionCityLinkMaybe;
